import { useEffect, type FC } from "react";
import { signOut } from "aws-amplify/auth";
import { useNavigate } from "react-router-dom";
import { setUser } from "../stores/user_store";
import { setCertificatePolicies } from "../stores/certificate_policy_store";
import { setDeviceGroups } from "../stores/device_group_store";

export const Logout: FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    signOut().finally(() => {
      // reset all stores
      setUser(undefined);
      setCertificatePolicies(undefined);
      setDeviceGroups(undefined);
      navigate("/");
    });
  }, [navigate]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 16,
        background: "var(--vmx-bg)",
      }}
    >
      <div className="vmx-spinner" />
      <div
        style={{
          fontSize: "1rem",
          fontWeight: 500,
          color: "var(--vmx-gray-600)",
        }}
      >
        Signing out...
      </div>
    </div>
  );
};
